export default "__VITE_ASSET__DmPNvppo__"